// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 468 ? "pricelists-pdf" : chunkId) + "." + {"468":"d3525c58daf13a63ccc0","884":"3297ab6d464b73ce5e05"}[chunkId] + ".css";
};